



























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { DataBus, TireStoringInfo, TireTypeEnum } from '@/models';
import { toastService } from '@/services';

@Component
export default class PaintImage extends Vue {
  @Prop() private tire!: TireStoringInfo;
  @Prop() private image!: HTMLImageElement;
  private width!: string;
  private height!: string;
  private isLocked: boolean = false;
  private isReNew: boolean = false;
  private TireTypeEnum = TireTypeEnum;

  private options = {
    backgroundColor: 'rgb(255, 255, 255)',
    penColor: 'rgba(255, 0, 0, 0.5)',
  };

  private created() {
    this.width = this.image.width + 'px';
    this.height = this.image.height + 'px';
    // Prevent image go blank when resize window
    window.addEventListener('resize', (event) => {
      if ((this.$refs.signaturePad as any)) {
        const signature = (this.$refs.signaturePad as any).saveSignature();
        let canvas = document.createElement('canvas');
        canvas.width = this.image.width; // desired width of merged images
        canvas.height = this.image.height; // desired height of merged images
        const ctx = canvas.getContext('2d');

        let image = new Image();
        let signatureImage = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        signatureImage.setAttribute('crossOrigin', 'anonymous');

        image.src = this.image.src;
        image.onload = () => {
          if (ctx) {
            ctx.drawImage(image, 0, 0);
            signatureImage.src = signature.data;
            signatureImage.onload = () => {
              ctx.drawImage(signatureImage, 0, 0);
              let data: any = canvas.toDataURL();
              if (data) {
                (this.$refs.signaturePad as any).resizeCanvas();
                (this.$refs.signaturePad as any).fromDataURL(data);
              }
            };
          }    
        };
      }
    }, false);
  }

  private mounted() {
    (this.$refs.signaturePad as any).fromDataURL(this.image.src);
  }

  private enableEdit() {
    (this.$refs.signaturePad as any).openSignaturePad();
    (this.$refs.signaturePad as any).$el.lastChild.style['touch-action'] = 'none';
    this.isLocked = false;
  }

  private disableEdit() {
    (this.$refs.signaturePad as any).lockSignaturePad();
    (this.$refs.signaturePad as any).$el.lastChild.style['touch-action'] = 'auto';
    this.isLocked = true;
  }

  private goBack() {
    this.$emit('event', new DataBus({
      event: 'back',
    }));
  }

  private undoPad() {
    (this.$refs.signaturePad as any).undoSignature();
    (this.$refs.signaturePad as any).fromDataURL(this.image.src);
  }

  private clearPad() {
    (this.$refs.signaturePad as any).clearSignature();
    (this.$refs.signaturePad as any).fromDataURL(this.image.src);
  }

  private reNewPad() {
    // const templateUrl = require('@/assets/img/tire_scratch.png');
    // his.image.src = templateUrl;
    (this.$refs.signaturePad as any).clearSignature();
    (this.$refs.signaturePad as any).resizeCanvas();
    (this.$refs.signaturePad as any).fromDataURL(this.image.src);
  }

  private saveImage() {
    const signature = (this.$refs.signaturePad as any).saveSignature();
    let canvas = document.createElement('canvas');
    canvas.width = this.image.width; // desired width of merged images
    canvas.height = this.image.height; // desired height of merged images
    const ctx = canvas.getContext('2d');

    let image = new Image();
    let signatureImage = new Image();
    image.setAttribute('crossOrigin', 'anonymous');
    signatureImage.setAttribute('crossOrigin', 'anonymous');

    image.src = this.image.src;
    image.onload = () => {
      if (ctx) {
        ctx.drawImage(image, 0, 0);
        signatureImage.src = signature.data;
        signatureImage.onload = () => {
          ctx.drawImage(signatureImage, 0, 0);
          const data = canvas.toDataURL();
          this.$emit('event', new DataBus({
            event: 'save',
            data: data,
          }));
        };
      }    
    };

    // this.mergeImageURIs([signature.data], this.image.width, this.image.height)
    //   .then((res) => {
    //     debugger
    //     this.$emit('event', new DataBus({
    //       event: 'save',
    //       data: res,
    //     }));
    //   });
  }

  // private mergeImageURIs(images: string[], width: number, height: number): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     let canvas = document.createElement('canvas');
  //     canvas.width = width; // desired width of merged images
  //     canvas.height = height; // desired height of merged images
  //     Promise.all(images.map((imageData) => this.add2canvas(canvas, imageData)))
  //       .then(() => {
  //         resolve(canvas.toDataURL());
  //       });
  //   });
  // }

  // private add2canvas(canvas: any, imageData: string): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     let image = new Image();
  //     image.setAttribute('crossOrigin', 'anonymous');
  //     image.src = imageData;
  //     image.onload = () => {
  //       canvas.getContext('2d').drawImage(image, 0, 0);
  //       resolve();
  //     };
  //   });
  // }

}
